import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { UserApi } from '../api';

export function useMembershipExpiryDate() {
  const { data: user } = useQuery('user', UserApi.fetch);

  const expiryDate = useMemo(() => {
    const raw = user?.membership_active_to;
    if (!raw) return undefined;

    const d = new Date(raw);
    return isNaN(d.getTime()) ? undefined : d;
  }, [user?.membership_active_to]);

  const isExpirySoon = useMemo(() => {
    if (!expiryDate) return false;
    const now = new Date();
    const diffDays = (expiryDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
    return diffDays >= 0 && diffDays <= 45;
  }, [expiryDate]);

  return {
    expiryDate,
    isExpirySoon,
    isValid: Boolean(user?.is_valid),
  };
}